import React, { useState, useEffect } from "react";
import { ReactSlider } from "react-slider-image-js";
import "react-slider-image-js/dist/index.css";
import $ from "jquery";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import { MDBInput, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
// import "../../Componentes/www/style.css";
import "../../Componentes/www/invoice.css";
import { MONEY_ROUND, roundNumber } from "../Util";
import { Decimal } from "decimal.js";
import { Container, Row, Col, Label } from "reactstrap";
import { reactLocalStorage } from "reactjs-localstorage";
import { LOGO, YAPPY_IMAGE_PUBLICIDAD } from "../Image";
import { get_img_publicidad, imgURLLocalImageIp, imgURLocalImage, imgURLServerPublicidad } from "./../Services";
var x = reactLocalStorage.getObject("tokenP");

export const SegundaPantalla = () => {
  const [dataPublicidad, setDataPublicidad] = useState([]);
  const [flagYappy, setFlagYappy] = useState(false);
  const [flagDatos, setFlagDatos] = useState(false);
  const [storage, setDataStorage] = useState([]);

  async function fetchPublicidad() {
    var response;
    response = await get_img_publicidad();

    var ObjItems = [];
    response.map((data) => {
      if (data.img_yappy === "0") {
        ObjItems.push({
          src: imgURLLocalImageIp + data.img_name,
        });
      }

      return null;
    });
    setDataPublicidad(ObjItems);
  }

  async function fetchStorage() {
    const x = reactLocalStorage.getObject("tokenP");

    setDataStorage(x);

    if (x?.dataFacturaDetallePr?.dataFacturaDetalle !== undefined) {
      setFlagDatos(true);
    } else {
      setFlagDatos(false);
    }

    let xx = false;

    if (x?.dataFacturaDetallePr?.dataListPago) {
      x.dataFacturaDetallePr.dataListPago.find((data) => {
        if (data.list_fpagoName === "PAGO POR YAPPY") {
          xx = true;
          return true;
        }

        return false;
      });
    }

    setFlagYappy(xx);

    setTimeout(() => {
      fetchStorage();
    }, 500);
  }

  useEffect(() => {
    fetchPublicidad();
    fetchStorage();
    document.title = "MTC - Pantalla Cliente";
  }, []);

  var descuento = new Decimal(0);
  var subtotal = new Decimal(0);
  var itbms = new Decimal(0);
  var total = new Decimal(0);
  if (flagDatos) {
    storage.dataFacturaDetallePr.dataFacturaDetalle.map((row) => {
      descuento = descuento.plus(new Decimal(row.fcd_descuento || 0));
      subtotal = subtotal.plus(new Decimal(row.fcd_cantidad).times(row.fcd_precio));
      itbms = itbms.plus(row.fcd_itbms ?? 0);
      return null;
    });
    total = subtotal.plus(itbms);
  }
  if (flagDatos) {
  }
  subtotal = MONEY_ROUND(subtotal, 2);
  itbms = MONEY_ROUND(itbms, 2);
  descuento = MONEY_ROUND(descuento);
  total = MONEY_ROUND(total, 2);

  return (
    <Container fluid className="customer-screen">
      <Row className="customer-layout g-0">
        {/* =========================
          PUBLICIDAD
      ========================== */}
        <Col lg={5} xs={12} className="customer-ad">
          <div className="customer-ad-content">
            {flagYappy ? (
              <img src={imgURLLocalImageIp + x.dataCompania.img_yappy} className="ad-logo" alt="Publicidad" />
            ) : dataPublicidad[0] !== undefined ? (
              <ReactSlider sliderIndex={0} images={dataPublicidad} slideAnimationDuration="600ms" imageBackgroundColor="#111" objectFit="contain" isAutoSlide={true} autoSlideDuration={15000} />
            ) : (
              <div className="customer-ad-empty">
                <img src={LOGO} className="ad-logo" alt="Publicidad" />

                <span>Gracias por visitarnos!</span>
              </div>
            )}
          </div>
        </Col>

        {/* =========================
          FACTURA
      ========================== */}
        <Col lg={7} xs={12} className="customer-panel">
          {/* HEADER */}

          <div className="customer-header">
            <div className="customer-info">
              <div className="customer-title">
                <div className="customer-title-icon">
                  <MDBIcon fas icon="user" />
                </div>

                <div>
                  <span>CLIENTE</span>

                  <strong>{flagDatos ? storage.dataFacturaDetallePr.formClientes.cli_nombre : "CONSUMIDOR FINAL"}</strong>
                </div>
              </div>

              <div className="customer-info-secondary">
                <div className="info-line">
                  <MDBIcon fas icon="id-card" />

                  <span>RUC</span>

                  <b>{flagDatos && storage.dataFacturaDetallePr.formClientes.cli_ruc ? `${storage.dataFacturaDetallePr.formClientes.cli_ruc} DV: ${storage.dataFacturaDetallePr.formClientes.cli_dv || ""}` : "--"}</b>
                </div>

                <div className="info-line">
                  <MDBIcon fas icon="envelope" />

                  <span>EMAIL</span>

                  <b>{flagDatos ? storage.dataFacturaDetallePr.formClientes.cli_email || "--" : "--"}</b>
                </div>
              </div>
            </div>

            <div className="customer-time-box">
              <span>FACTURACIÓN</span>

              <strong>
                {new Date().toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </strong>

              <small>{new Date().toLocaleDateString()}</small>
            </div>
          </div>

          {/* =========================
            TITULO DETALLE
        ========================== */}

          <div className="customer-detail-header">
            <div>
              <MDBIcon fas icon="shopping-cart" />

              <span>Detalle de compra</span>
            </div>

            <span className="customer-item-count">{flagDatos ? storage.dataFacturaDetallePr.dataFacturaDetalle.length : 0} artículos</span>
          </div>

          {/* =========================
            TABLA
        ========================== */}

          <div className="customer-table-wrapper">
            <MDBTable className="customer-table">
              <MDBTableHead>
                <tr>
                  <th className="col-description">DESCRIPCIÓN</th>
                  <th className="col-price">PRECIO</th>
                  <th className="col-qty">CANT.</th>
                  <th className="col-discount">DESC.</th>
                  <th className="col-total">TOTAL</th>
                </tr>
              </MDBTableHead>

              <MDBTableBody>
                {flagDatos &&
                  storage.dataFacturaDetallePr.dataFacturaDetalle.map((data, i) => (
                    <tr key={i}>
                      <td className="customer-description">
                        <div className="customer-description-wrap">
                          <span className="customer-description-name">{data.art_descripcion}</span>

                          {data.art_upc && <span className="customer-upc">Cód: {data.art_upc}</span>}
                        </div>
                      </td>

                      <td className="customer-number">${Number(data.fcd_precio || 0).toFixed(2)}</td>

                      <td className="customer-quantity">{Number(data.fcd_cantidad || 0).toFixed(0)}</td>

                      <td className="customer-discount">{Number(data.fcd_descuento || 0) > 0 ? `-$${Number(data.fcd_descuento).toFixed(2)}` : "--"}</td>

                      <td className="customer-total-cell">${Number(data.fcd_total || 0).toFixed(2)}</td>
                    </tr>
                  ))}
              </MDBTableBody>
            </MDBTable>
          </div>

          {/* =========================
            FOOTER
        ========================== */}

          <div>
            <Row>
              <Col xs={6} className="customer-footer">
                <div className="customer-brand">
                  <img src={LOGO} className="customer-brand-logo" alt="Logo" />

                  {/* {!flagYappy && ( */}
                  <div className="customer-thanks">
                    <strong>¡Gracias por visitarnos!</strong>
                    <span>Es un placer atenderle</span>

                    <small>Revise sus artículos antes de retirarse.</small>
                  </div>
                  {/* )} */}
                </div>
              </Col>
              <Col xs={6} className="customer-footer">
                <div className="customer-totals">
                  <div className="customer-total-line">
                    <span>SUBTOTAL</span>

                    <b>${Number(subtotal || 0).toFixed(2)}</b>
                  </div>
                  <div className="customer-total-line customer-total-discount">
                    <span>DESCUENTO</span>

                    <b className={Number(descuento || 0) > 0 ? "has-discount" : ""}>{Number(descuento || 0) > 0 ? `-$${Number(descuento).toFixed(2)}` : "$0.00"}</b>
                  </div>

                  <div className="customer-total-line">
                    <span>ITBMS</span>

                    <b>${Number(itbms || 0).toFixed(2)}</b>
                  </div>

                  <div className="customer-grand-total">
                    <span>TOTAL</span>

                    <strong>${Math.max(0, Number(total || 0) - Number(descuento || 0)).toFixed(2)}</strong>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
